import { render, staticRenderFns } from "./PayPalCheckoutButton.vue?vue&type=template&id=1430562b&"
import script from "./PayPalCheckoutButton.vue?vue&type=script&lang=js&"
export * from "./PayPalCheckoutButton.vue?vue&type=script&lang=js&"
import style0 from "./PayPalCheckoutButton.vue?vue&type=style&index=0&id=1430562b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports